export default "__VITE_PUBLIC_ASSET__875ffdb4__"